// extracted by mini-css-extract-plugin
export default {"formHeading":"zH-z","form":"AH-z","submitBtn":"BH-z","disabled":"CH-z","input":"DH-z","error":"EH-z","submitMsg":"FH-z","signIn":"GH-z"};